/**
 * Api结果码
 */
enum ApiCode {
  // 成功
  Success = 200,
  // 未登录 TODO 可能需要依据当前项目自行配置
  NoLogin = 601,
  // 企业微信没登录
  WechatNoLogin = 100401,
}

export default ApiCode;
